



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import CardResumeRalan from "@/components/pemeriksaan/resumeSuketV2/CardResumeRalan.vue";
import PemeriksaanReadonlyBanner from "@/components/pemeriksaan/PemeriksaanReadonlyBanner.vue";

import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";
import { userModule } from "@/store/modules/user";
import { PrefillSkdp } from "@/types/resumeRalanBlanko";
import { evaluatePemeriksaanReadOnly } from "@/utility/PemeriksaanReadonly";
import type { ActiveApproval } from "@/utility/PemeriksaanReadonly";
import { resetStorePasienRalan } from "@/utils/resetStorePasien";

@Component({
  components: {
    CardResumeRalan,
    PemeriksaanReadonlyBanner
  },
  provide() {
    const self = this as { readOnly?: boolean };

    return {
      isReadOnly: () => !!self.readOnly
    };
  }
})
export default class DialogResumeRalan extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ required: true }) readonly register!: string;
  @Prop({ default: "" }) readonly rm!: string;
  @Prop({ default: "" }) readonly nama!: string;

  ready = false;
  gagal = false;
  memuat = false;
  alasanGagal = "";
  nonce: number | null = null;
  skdpTertunda: PrefillSkdp | null = null;

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get pasienLabel(): string {
    return [this.rm, this.nama].filter(Boolean).join(" — ");
  }

  get activeApproval(): ActiveApproval | null {
    const reg: any = this.registerKunjungan;
    const no = reg ? reg.no : null;

    if (!no) {
      return null;
    }

    const snap = revisionAccessModule.activeByRegister[no];

    if (!snap || !snap.has_active || !snap.active) {
      return null;
    }

    return {
      expiresAt: snap.active.expires_at,
      approvedAt: snap.active.approved_at,
      grantedMinutes: snap.active.granted_minutes
    };
  }

  get readOnlyResult() {
    return evaluatePemeriksaanReadOnly(
      this.registerKunjungan,
      new Date(),
      this.activeApproval,
      userModule.unitGate
    );
  }

  get readOnly(): boolean {
    return this.readOnlyResult.readOnly;
  }

  @Watch("value")
  onToggle(val: boolean) {
    if (val) {
      this.muat();
    } else {
      this.bersihkan();
    }
  }

  async muat() {
    if (this.memuat || !this.register) {
      return;
    }

    this.memuat = true;
    this.ready = false;
    this.gagal = false;
    this.alasanGagal = "";
    this.skdpTertunda = null;

    resetStorePasienRalan();

    const reg = this.register;

    try {
      await RegisterKunjungan.getRegister(reg).catch(() => undefined);

      const kunjungan: any = RegisterKunjungan.register;

      if (!kunjungan) {
        this.alasanGagal = "Data register tidak dapat dimuat.";

        throw new Error("register tidak ditemukan");
      }

      const sudahPulang =
        !!kunjungan.discharge_at ||
        (!!kunjungan.dout && kunjungan.dout !== "0000-00-00");

      await Promise.all([
        sudahPulang
          ? revisionAccessModule.fetchActive(kunjungan.no).catch(() => undefined)
          : undefined,
        kunjungan.is_bpjs
          ? RegisterKunjungan.getInfoBpjs(kunjungan.no).catch(() => undefined)
          : undefined
      ]);

      if (String(reg) !== String(this.register) || !this.value) {
        return;
      }

      this.nonce = Date.now();
      this.ready = true;
    } catch (e) {
      this.gagal = true;
    } finally {
      this.memuat = false;
    }
  }

  bersihkan() {
    const skdp = this.skdpTertunda;

    this.ready = false;
    this.gagal = false;
    this.alasanGagal = "";
    this.skdpTertunda = null;

    resetStorePasienRalan();

    this.$emit("closed");

    if (skdp) {
      this.$emit("buat-skdp", skdp);
    }
  }

  teruskanSkdp(prefill: PrefillSkdp) {
    this.skdpTertunda = prefill;
    this.tutup();
  }

  tutup() {
    this.$emit("input", false);
  }

  beforeDestroy() {
    if (this.ready) {
      resetStorePasienRalan();
    }
  }
}
